import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import 'moment/locale/pt-br'
import moment from 'moment';

import App from './App';
import { loginBff } from './services/bff/bffApi';

moment.locale('pt-br');

// Dispara a sessão do BFF (cookie bff.session) já no start, antes do primeiro render.
// As chamadas de negócio aguardam esta mesma promise no interceptor do bffApi.
loginBff().catch(() => undefined);

ReactDOM.render(
  <ConfigProvider locale={ptBR}>
    <App />
  </ConfigProvider>,
  document.getElementById('root'),
);
